
<template>
  <div class="page-wrapper">
    <div class="wrapper max30 ">
    <seach-list class="mb16"  @getdata="getData2"></seach-list>
    </div>

     <div class="history">
      <Tabs v-model="currentTab" class="toph-tabs"  @on-click="changeTab">
        <TabPane label="浏览记录" name="BROWSE"></TabPane>
        <TabPane label="收藏记录" name="COLLECTION"></TabPane>
        <TabPane label="客史入住记录" name="GUEST"></TabPane>
      </Tabs>
       <keep-alive>
         <div v-if="currentTab=='BROWSE'">
            <table-list
                   :columns="browseColumns"
                   :data="browseTabelData"
                   :loading="browseTableLoading"
                   :current="browseCurrent"
                   :total="browseTotal"
                   @change-page="browseChangPage"
                   :pageSize="5"
                 >
            </table-list>
         </div>
       </keep-alive>
       <keep-alive>
          <div v-if="currentTab=='COLLECTION'">
            <table-list
                      :columns="collecitonColumns"
                      :data="collectionTabelData"
                      :loading="collectionTableLoading"
                      :current="collectionCurrent"
                      :total="collectionTotal"
                      @change-page="collectionChangPage"
                      :pageSize="5"
                    ></table-list>
          </div>
      </keep-alive>
     <keep-alive>
       <div v-if="currentTab=='GUEST'">
         <table-list
             :columns="contractColumns"
             :data="contractTabelData"
             :loading="contractTableLoading"
             :current="contractTableCurrent"
             :total="contractTableTotal"
             @change-page="contractTableChangPage"
             :pageSize="5"
          ></table-list>
      </div>
     </keep-alive>
        <div ref="echarts"  style="width:1000px;height:400px">
       </div>

  </div>
 </div>
</template>

<script>
  import SeachList from '../components/SearchListHouseType'
  import {getBrowseHistoryList,getHouseTypeCollectionList,getHouseTypeCollectionCount,getHouseTypeContractList,getHouseTypeContractCount,getHouseTypeBrowseList,getHouseTypeBrowseCount} from "../../../api/reporter"
  import TableList from 'components/TableList/index'
  let echarts = require('echarts/lib/echarts')
    require('echarts/lib/chart/funnel')
    require("echarts/lib/component/tooltip")
    require('echarts/theme/macarons')

  export default {
    props:{

      },
    name: "housetypearchives",
    data(){
      return {
        currentTab:'BROWSE',
        projectList:[],
        projectFid: '',
        personLonLatVos: [],
        searchData:{},
        project: {},
        browseCurrent:1,
        collectionCurrent:1,
        contractTableCurrent:1,
        browseQueryDto: {
          projectFid: '',
          houseTypeFid:'',
          startDate:'',
          endDate:'',
          page: 1,
          limit: 1
        },
        collecitonColumns:[
             {
               title: '房型名称(单位:元)',
               key: 'houseTypeName',
               align: 'center'
             },
              {
                title: '房型价格',
                align: 'center',
                render: (h, params) => {
                        return h('div', params.row.minPrice + ' - ' + params.row.maxPrice)
                    }
              },
             {
                title: '用户姓名',
                key: 'nickName',
                align: 'center'
              },
             {
               title: '收藏时间',
               key: 'createDate',
               align: 'center'
             }
        ],
        browseColumns:[
           {
             title: '房型名称',
             key: 'houseTypeName',
             align: 'center'
           },
           {
            title: '房型价格(单位:元)',
            align: 'center',
            render: (h, params) => {
                    return h('div', params.row.minPrice + ' - ' + params.row.maxPrice)
                }
          },
           {
              title: '用户姓名',
              key: 'nickName',
              align: 'center'
            },
           {
             title: '浏览时间',
             key: 'createDate',
             align: 'center'
           }
         ],
        collecitonColumns:[
          {
             title: '房型名称',
             key: 'houseTypeName',
             align: 'center'
           },
          {
              title: '房型价格(单位:元)',
              align: 'center',
              render: (h, params) => {
                    return h('div', params.row.minPrice + ' - ' + params.row.maxPrice)
                }
           },
           {
             title: '用户名称',
             key: 'nickName',
             align: 'center'
           },
           {
             title: '收藏时间',
             key: 'createDate',
             align: 'center'
           }
        ],
        contractColumns:[
                 {
                   title: '房型名称',
                   key: 'houseTypeName',
                   align: 'center'
                 },
                 {
                   title: '房间名称',
                   key: 'stockNumber',
                   align: 'center'
                 },
                 {
                   title: '合同开始日期',
                   key: 'conStartDate',
                   align: 'center'
                 },
                 {
                   title: '合同截止日期',
                   key: 'conEndDate',
                   align: 'center'
                 },
                 {
                   title: '月租金(单位:元)',
                   key: 'actualHousePrice',
                   align: 'center'
                 },
                 {
                   title: '合同状态',
                   key: 'contractStateStr',
                   align: 'center'
                 }
               ],
         contractTabelData:[],
         browseTabelData: [],
         collectionTabelData:[],
         contractTableLoading:false,
         browseTableLoading: false,
         collectionTableLoading:false,
         browseTotal: 0,
         collectionTotal:0,
         contractTableTotal:0,
         amount: null,
         chart: null,
         option:{
             title: {
                 text: '房型访问统计'
             },
             tooltip: {},
             legend: {
                 data:['销量']
             },
             xAxis: {
                 data: ['衬衫','羊毛衫','雪纺衫','裤子','高跟鞋','袜子']
             },
             yAxis: {},
             series: [
               {type:'bar',
                   label: {
                     show: true,
                     position: 'top',
                     textStyle: {
                       color: '#615a5a'
                     },
                     formatter:function(params){
                         return params.value.count;
                     }
               }},
               {type:'bar',
                 label: {
                   show: true,
                   position: 'top',
                   textStyle: {
                     color: '#615a5a'
                   },
                   formatter:function(params){
                       return params.value.stockCount;
                   }
                 }}],
             dataset: {
               source: [
                 ['product', '2015', '2016', '2017'],
                 ['Matcha Latte', 43.3, 85.8, 93.7],
                 ['Milk Tea', 83.1, 73.4, 55.1],
                 ['Cheese Cocoa', 86.4, 65.2, 82.5],
                 ['Walnut Brownie', 72.4, 53.9, 39.1]
               ]
             },
             color: ['#20c5e6', '#2ccc70']
         }
      }
    },
    components:{
        SeachList,
        TableList

    },
    methods:{
      changeTab(){
        if(this.currentTab ==='BROWSE'){
          this.getBrowseHistory(this.browseCurrent)
        }
        if(this.currentTab ==='COLLECTION'){
          this.getHouseTypeCollection(this.collectionCurrent);
        }
        if(this.currentTab ==='GUEST'){
             this.getHouseTypeContractList(this.contractTableCurrent);
        }
        this.getPage();

      },
      getPage(){
        if(this.currentTab ==='BROWSE'){
          this.option.legend = { data:['浏览数量', '库存'] };
          this.option.title ={text: '房型浏览记录统计' } ;
          getHouseTypeBrowseCount(this.browseQueryDto).then(res =>{
              if(res.code==0) {
                 var houseTypeCountCur = [];
                 var type = ['product', '浏览数量', '库存'];
                houseTypeCountCur.push(type)
                 res.data.forEach((ele, index) => {
                   let arr = []
                   arr.push(ele.houseTypeName, ele.count, ele.stockCount)
                   houseTypeCountCur.push(arr)
                 })
                this.option.dataset.source = houseTypeCountCur;
                 this.option.xAxis ={ type: 'category' };
              }else {
                this.$Message.warning(res.message);
              }
               this.browseTableLoading = false;
               this.chart=echarts.init(this.$refs.echarts);
               this.chart.setOption(this.option, true);
            }).catch(error => {
             })
        }
        if(this.currentTab ==='COLLECTION'){
         this.option.legend = { data:['收藏数量', '库存'] };
         this.option.title ={text: '房型收藏记录统计' } ;
         getHouseTypeCollectionCount(this.browseQueryDto).then(res =>{
               if(res.code==0) {
                  var houseTypeCountCur = [];
                  var type = ['product', '收藏数量', '库存'];
                  houseTypeCountCur.push(type)
                  res.data.forEach((ele, index) => {
                    let arr = []
                    arr.push(ele.houseTypeName, ele.count, ele.stockCount)
                    houseTypeCountCur.push(arr)
                  })
                 this.option.dataset.source = houseTypeCountCur;
                 this.option.xAxis ={ type: 'category' };
               }else {
                 this.$Message.warning(res.message);
               }
                this.collectionTableLoading = false;
                this.chart=echarts.init(this.$refs.echarts);
                this.chart.setOption(this.option, true);
             }).catch(error => {
              })

        }
        if(this.currentTab ==='GUEST'){
            this.option.legend = { data:['历史入住房客数量', '库存'] };
            this.option.title ={text: '房型历史入住统计' } ;
            getHouseTypeContractCount(this.browseQueryDto).then(res =>{
                  if(res.code==0) {
                    var houseTypeCountCur = [];
                    var type = ['product', '历史入住房客数量', '库存'];
                    houseTypeCountCur.push(type)
                     res.data.forEach((ele, index) => {
                       let arr = []
                       arr.push(ele.houseTypeName, ele.count, ele.stockCount)
                       houseTypeCountCur.push(arr)
                     })
                    this.option.dataset.source = houseTypeCountCur;
                    this.option.xAxis ={ type: 'category' };
                  }else {
                    this.$Message.warning(res.message);
                  }
                   this.contractTableLoading = false
                   this.chart=echarts.init(this.$refs.echarts);
                   this.chart.setOption(this.option, true);
                }).catch(error => {
                 })

        }


        // this.chart.setOption(this.option);
        },
      ok(){
          if(this.projectFid === null){
              this.$Message.info('所选项目为空')
              return
           }
         this.changeTab();
       },
     getBrowseHistory(n){

        this.browseTableLoading = true;
        this.browseCurrent = n;
        this.browseQueryDto.projectFid = this.searchData.projectFids;
        this.browseQueryDto.houseTypeFid = this.searchData.houseTypeFid;
        this.browseQueryDto.startDate = this.searchData.startTime;
        this.browseQueryDto.endDate = this.searchData.endTime;
        this.browseQueryDto.page = n
        this.browseQueryDto.limit = 5;

        getHouseTypeBrowseList(this.browseQueryDto).then(res =>{
              if(res.code==0) {
                 if(!res.data){
                     return
                 }
                this.browseTabelData = res.data.rows;
                this.browseTotal = res.data.total;
                this.browseTableLoading = false
              }else {
                this.$Message.warning(res.message);
              }
               this.browseTableLoading = false
            }).catch(error => {
             })
     },
     getHouseTypeCollection(n){
       //收藏历史
      this.collectionTableLoading = true;
      this.browseQueryDto.projectFid = this.searchData.projectFids;
      this.browseQueryDto.houseTypeFid = this.searchData.houseTypeFid;
      this.browseQueryDto.startDate = this.searchData.startTime;
      this.browseQueryDto.endDate = this.searchData.endTime;
      this.browseQueryDto.page = n;
      this.browseQueryDto.limit = 5;
      getHouseTypeCollectionList(this.browseQueryDto).then(res =>{
         if(res.code==0) {

           this.collectionTabelData = res.data.rows
           this.collectionTotal = res.data.total
         }else {
           this.$Message.warning(res.message);
         }
          this.collectionTableLoading = false
       }).catch(error => {
        })
     },
     getHouseTypeContractList(n){
            //客史历史
           this.browseTableLoading = true;
           this.browseQueryDto.projectFid = this.searchData.projectFids;
           this.browseQueryDto.houseTypeFid = this.searchData.houseTypeFid;
           this.browseQueryDto.startDate = this.searchData.startTime;
           this.browseQueryDto.endDate = this.searchData.endTime;
           this.browseQueryDto.page = n;
           this.browseQueryDto.limit = 5;
           getHouseTypeContractList(this.browseQueryDto).then(res =>{
              if(res.code==0) {

                this.contractTabelData = res.data.rows
                this.contractTableTotal = res.data.total
              }else {
                this.$Message.warning(res.message);
              }
               this.contractTableLoading = false
            }).catch(error => {
             })
     },
     getData2(params){
         this.searchData=params
         this.searchData.startTime = this.searchData.startTime + ' 00:00:00'
         this.searchData.endTime = this.searchData.endTime + ' 23:59:59'
         this.getData()

       },
    getData(){
         //初始化列表
         this.changeTab();

       },
    browseChangPage (n) {
       this.getBrowseHistory(n);
    },
    collectionChangPage(n){
     this.getHouseTypeCollection(n);
    },
    contractTableChangPage(n){
       this.getHouseTypeContractList(n);
    }
    },
    mounted(){

     },
    created(){

    }
  }
</script>

<style scoped>
  .input{
    display: inline-block;
    width: 250px;
    margin-right: 20px;
  }
  .wrapper{
    display: flex;
    align-items: center;
    /*justify-content: space-between;*/
  }
  .my-map-contain{
    height: 600px;
    width: 100%;
    border: solid 1px #dddee1;
    border-radius: 4px;
    margin-top: 20px;
  }
  .history{
  margin-top: 20px;
  }
</style>
